const daySeconds = 24 * 3600 * 1000;
const hourSeconds = 3600 * 1000;
const minSeconds = 60 * 1000;

const prettyDate = (s) => {
  if (!s) return '';

  const now = new Date().getTime();
  const t = new Date(s).getTime();

  const dis = now - t;

  if (dis >= daySeconds) {
    return `${parseInt(dis/daySeconds)} days ago`;
  }

  if (dis >= hourSeconds) {
    return `${parseInt(dis/hourSeconds)} hours ago`;
  }

  if (dis >= minSeconds) {
    return `${parseInt(dis/minSeconds)} minutes ago`;
  }

  return `${parseInt(dis/1000)} seconds ago`;
};

// 1 -> "01"
const twoDigitsFormat = (v) => {
  let m = v + '';
  if (m.length === 1) {
    m = `0${m}`;
  }
  return m;
};

const stringifyDayTime = (hour, minute) => {
  return `${twoDigitsFormat(hour)}:${twoDigitsFormat(minute)}`;
};

// 12:00
const parseDayTime = (time) => {
  const [hour, minute] = time.split(':');

  return {
    hour: Number(hour),
    minute: Number(minute),
  };
};

function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

export {
  prettyDate,
  twoDigitsFormat,
  stringifyDayTime,
  parseDayTime,
  daysInMonth,
};
